import { useEffect, useState } from 'react';
import { fetchDocuments, selectAllDocuments } from '../../../slices/documents/documentsSlice';
import { fetchDisclaimerInfo } from '../../../slices/disclaimer/disclaimerSlice';
import { NWClient } from '../../../client/NWClient';
import { LibraryItem } from '../../library/components/library-list/types';
import {
  fetchDocumentTemplates,
  selectAllDocumentTemplates,
} from '../../../slices/document-templates/documentTemplatesSlice';
import { useAppDispatch } from '../../../common/hooks/useAppDispatch';
import { useAppSelector } from '../../../common/hooks/useAppSelector';
import { selectUser } from '../../../slices/user/userSlice';
import {
  fetchDocumentContracts,
  selectAllDocumentContracts,
} from '../../../slices/document-contracts/documentContractsSlice';

export const useWorkspace = () => {
  const currentUser = useAppSelector(selectUser);
  const dispatch = useAppDispatch();
  const documentContracts = useAppSelector(selectAllDocumentContracts);
  const documentUploads = useAppSelector(selectAllDocuments);
  const documentTemplates = [...useAppSelector(selectAllDocumentTemplates)].filter(
    (el) => el.last_used !== null
  );
  const [activeTab, setActiveTab] = useState<'All' | 'Documents' | 'Templates'>('All');
  const [documentLibraryItems, setDocumentLibraryItems] = useState<LibraryItem[]>([]);
  const [pendingStatus, setPendingStatus] = useState<boolean>(false);
  const handleTabChange = (tab: 'All' | 'Documents' | 'Templates') => {
    setActiveTab(tab);
  };
  const sortByDate = (a: any, b: any) => {
    return Number(new Date(b.last_used || b.updated)) - Number(new Date(a.last_used || a.updated));
  };

  const workspaceItemsArray = () => {
    switch (activeTab) {
      case 'All':
        return [
          ...documentContracts,
          ...documentUploads,
          ...[...documentLibraryItems].filter((el) => el.last_used !== null),
          ...documentTemplates,
        ];
      case 'Documents':
        return [...documentContracts, ...documentUploads];
      case 'Templates':
        return [
          ...[...documentLibraryItems].filter((el) => el.last_used !== null),
          ...documentTemplates,
        ];
    }
  };
  const workspaceItems = [...workspaceItemsArray()].sort((a, b) => sortByDate(a, b)).slice(0, 10);
  useEffect(() => {
    if (currentUser) {
      if (activeTab === 'All') {
        dispatch(
          fetchDocuments({
            data: {
              user: currentUser.id,
            },
          })
        );
        dispatch(
          fetchDocumentContracts({
            data: {
              user: currentUser.id,
            },
          })
        );
        dispatch(fetchDocumentTemplates({ data: { user: currentUser.id } }));
        NWClient.list('document-library')
          .then((res: LibraryItem[]) => {
            setDocumentLibraryItems(res);
          })
          .finally(() => {
            setPendingStatus(false);
          });
      } else if (activeTab === 'Documents') {
        dispatch(
          fetchDocuments({
            data: {
              user: currentUser.id,
            },
          })
        );
        dispatch(
          fetchDocumentContracts({
            data: {
              user: currentUser.id,
            },
          })
        );
      } else if (activeTab === 'Templates') {
        dispatch(fetchDocumentTemplates({ data: { user: currentUser.id } }));
        NWClient.list('document-library')
          .then((res: LibraryItem[]) => {
            setDocumentLibraryItems(res);
          })
          .finally(() => {
            setPendingStatus(false);
          });
      }
    }
  }, [currentUser, activeTab]);

  useEffect(() => {
    dispatch(fetchDisclaimerInfo());
  }, []);

  return {
    activeTab,
    handleTabChange,
    pendingStatus,
    workspaceItems,
  };
};
